import axios from 'axios'

function initialState() {
  return {
    datumList: [],
  }
}

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async getDatumList() {
      let url = 'api/Datums'
      try {
        axios.get(url)
          .then(res => {
            return res.data
          })
      } catch (e) {
        console.log('Could not get datums from \'' + url + '\'')
      }
    },
    async getDatumListForTenant({ commit }, options) {
      let url = 'api/Datums/' + options.tenantName
      try {
        axios.get(url)
          .then(res => {
            commit('SET_DatumList', res.data)
            options.successCb(res.data)
          })
      } catch (e) {
        console.log('Could not get datums from \'' + url + '\'')
      }
    },
    async postDatum({ commit }, options) {
      let url = '/api/Datums/' + options.tenantName
      try {
        axios.post(url, options.data)
          .then(res => {
            options.successCb(res.data)
          })
      } catch (e) {
        console.error('Could not create new datum', e)
      }
    },
    async putDatum({ commit }, options) {
      let url = '/api/Datums/' + options.tenantName
      try {
        axios.put(url, options.data)
          .then(res => {
            options.successCb(res.data)
          })
      } catch (e) {
        console.log('Could not edit datum')
      }
    },
    async deleteDatum({ commit }, options) {
      let url = '/api/Datums/' + options.tenantName
      try {
        console.log(options.data)
        axios.delete(url, {
          data: options.data,
        })
          .then(res => {
            options.successCb(res.data)
          })
      } catch (e) {
        options.failedCb(e)
        console.log('Could not delete datum')
      }
    },
    async getDatumDetails({ commit }, options) {
      let url = '/api/Datum/' + options.tenantName
      try {
        axios.post(url, options.data)
          .then(res => {
            options.successCb(res.data)
          })
      } catch (e) {
        console.log('Could not get datum details')
      }
    },
  },
  mutations: {
    SET_DatumList: (state, data) => state.datumList = data,
  },
  getters: {
    'datumList': (state) => state.datumList,
  },
}